var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
    stroke: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.092 6.101a.29.29 0 0 1-.198-.079c-.67-.644-1.25-.118-1.368-.013-.105.119-.29.119-.408.013-.119-.105-.119-.29-.013-.408.013-.013.46-.473 1.079-.486.381-.014.763.158 1.092.473.118.106.118.29.013.408a.257.257 0 0 1-.197.092ZM10.67 6.101a.29.29 0 0 1-.197-.079c-.67-.644-1.25-.118-1.368-.013-.105.119-.29.119-.408.013-.118-.105-.118-.29-.013-.408.013-.013.46-.473 1.079-.486.395-.014.763.158 1.092.473.118.106.118.29.013.408a.257.257 0 0 1-.197.092ZM7 10.72a3.219 3.219 0 0 0 3.184-2.75c.04-.237-.157-.448-.394-.448H4.21a.402.402 0 0 0-.394.447A3.219 3.219 0 0 0 7 10.72Z",
    fill: "#F5F6FA"
  })));
};

export default SvgSmile;